import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AddCommentPayload,
  ApproveExpensePayload,
  EditExpensePayload,
  EditExpenseResponse,
  ExpenseCommonResponse,
  ExpensesPayload,
} from '@core/interface/expense';
import { ExpenseResponse, ExpensesTypeResponse } from '@core/interface/expense';
import { environment } from '@environment/environment';

@Injectable({
  providedIn: 'root',
})
export class ExpenseService {
  constructor(private http: HttpClient) {}

  getExpenses(data: ExpensesPayload) {
    let httpParams = new HttpParams();
    if (data)
      Object.keys(data).forEach((key) => {
        httpParams = httpParams.set(
          key,
          (data[key as keyof ExpensesPayload] as any) || ''
        );
      });
    return this.http.get<ExpenseResponse>(environment.endPoints.expenseList, {
      params: httpParams,
    });
  }
  getExpenseTypes() {
    return this.http.get<ExpensesTypeResponse>(
      environment.endPoints.expenseTypeList
    );
  }

  approveExpense(filter?: ApproveExpensePayload) {
    let httpParams = new HttpParams();
    if (filter)
      Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
          key,
          (filter[key as keyof ApproveExpensePayload] as any) || ''
        );
      });
    return this.http.get<ExpenseResponse>(
      environment.endPoints.approveExpense,
      {
        params: httpParams,
      }
    );
  }

  adminDirectApprove(ids: string) {
    return this.http.post<ExpenseCommonResponse>(
      environment.endPoints.expenseAdminDirectApprove,
      { ids },
      { headers: { 'Content-Type': 'application/json' } }
    );
  }

  editExpense(data?: EditExpensePayload) {
    return this.http.post<EditExpenseResponse>(
      environment.endPoints.addExpense,
      data
    );
  }

  addComment(data?: AddCommentPayload) {
    return this.http.post<EditExpenseResponse>(
      environment.endPoints.addExpenseComment,
      data
    );
  }
}
